import { useAuth } from "@/AuthContext";
import { Input } from "@/components/ui/input";

export function useCustomFields(entity) {
  const { user } = useAuth();
  return user?.tenant?.config?.custom_fields?.[entity] || [];
}

export function CustomFieldsForm({ entity, value, onChange }) {
  const fields = useCustomFields(entity);
  if (!fields.length) return null;
  const val = value || {};
  const set = (k, v) => onChange({ ...val, [k]: v });
  return (
    <div className="space-y-3 border-t pt-3 mt-1" data-testid={`custom-fields-${entity}`}>
      <div className="text-[11px] uppercase tracking-widest text-muted-foreground">Additional fields</div>
      {fields.map((f) => (
        <div key={f.key}>
          <label className="text-sm font-medium">{f.label}</label>
          {(f.type === "text" || f.type === "number" || f.type === "date" || f.type === "currency") && (
            <Input data-testid={`cf-${f.key}`} className="mt-1.5"
              type={f.type === "text" ? "text" : f.type === "date" ? "date" : "number"}
              value={val[f.key] ?? ""} onChange={(e) => set(f.key, e.target.value)} />
          )}
          {f.type === "checkbox" && (
            <label className="mt-1.5 flex items-center gap-2 text-sm">
              <input data-testid={`cf-${f.key}`} type="checkbox" checked={!!val[f.key]}
                onChange={(e) => set(f.key, e.target.checked)} className="w-4 h-4 accent-indigo-600" />
              {val[f.key] ? "Yes" : "No"}
            </label>
          )}
          {(f.type === "dropdown" || f.type === "multi-select") && (
            <select data-testid={`cf-${f.key}`} className="mt-1.5 w-full h-10 rounded-md border bg-background px-3 text-sm"
              value={val[f.key] ?? (f.type === "multi-select" ? [] : "")}
              multiple={f.type === "multi-select"}
              onChange={(e) => set(f.key, f.type === "multi-select"
                ? [...e.target.selectedOptions].map((o) => o.value) : e.target.value)}>
              {f.type === "dropdown" && <option value="">Select…</option>}
              {(f.options || []).map((o) => <option key={o} value={o}>{o}</option>)}
            </select>
          )}
        </div>
      ))}
    </div>
  );
}

export function CustomFieldsView({ entity, data }) {
  const fields = useCustomFields(entity);
  const val = data || {};
  const shown = fields.filter((f) => val[f.key] !== undefined && val[f.key] !== "" && val[f.key] !== null);
  if (!shown.length) return null;
  return (
    <div className="grid grid-cols-2 gap-2" data-testid={`custom-fields-view-${entity}`}>
      {shown.map((f) => (
        <div key={f.key} className="rounded-lg border bg-muted/40 px-3 py-2">
          <div className="text-[10px] uppercase tracking-widest text-muted-foreground">{f.label}</div>
          <div className="text-sm font-medium mt-0.5">
            {f.type === "checkbox" ? (val[f.key] ? "Yes" : "No") : Array.isArray(val[f.key]) ? val[f.key].join(", ") : String(val[f.key])}
          </div>
        </div>
      ))}
    </div>
  );
}
